import { useContext, useEffect, useState } from 'react';

import { getMeta } from '@swf/components/StarsWizard/Machine';
import { Context } from '@swf/components/StarsWizard/StarsWizard';

const useWizardLoading = (): { loading: boolean; service: string[] } => {
  const wizard = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [service, setService] = useState<string[]>([]);

  useEffect(() => {
    if (!wizard) {
      return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transitionHandler = ({ meta }: any) => {
      const { waiting } = getMeta(meta) as Record<string, boolean>;

      setService(Object.keys(meta));
      setLoading(waiting);
    };

    wizard.onTransition(transitionHandler);

    return () => {
      wizard.off(transitionHandler);
    };
  }, [wizard]);

  return { loading, service };
};

export default useWizardLoading;
